import gql from 'graphql-tag';

export const UserClaimsQuery = gql`
  query UserClaims {
    currentUser {
      claims {
        pharmacyPortal {
          dataUpload
        }
      }
    }
  }
`;
